import { useId, useMemo } from 'react'
import { LOGO_RING, LOGO_SMALL } from '../../lib/logoSvg'
import { SmartLink } from './SmartLink'

/** The mauj app icon. Gradient ids are made unique per instance so several logos can share a page. */
export function LogoMark({ variant = 'small', className }: { variant?: 'small' | 'ring'; className?: string }) {
  const raw = useId()
  const html = useMemo(() => {
    const prefix = `m${raw.replace(/[^a-zA-Z0-9]/g, '')}`
    return (variant === 'ring' ? LOGO_RING : LOGO_SMALL).replace(/__ID__/g, prefix)
  }, [raw, variant])
  return <span className={className ?? 'mark'} aria-hidden="true" dangerouslySetInnerHTML={{ __html: html }} />
}

export function Logo() {
  return (
    <SmartLink className="logo" to="/" aria-label="mauj home">
      <LogoMark />
      <span>mauj</span>
    </SmartLink>
  )
}
